module.exports = __webpack_public_path__ + "img/23.8.TSS.fef70f06.png";